/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputTarget
 */
export interface InputTarget {
    /**
     * 
     * @type {boolean}
     * @memberof InputTarget
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InputTarget
     */
    coords?: string;
    /**
     * 
     * @type {string}
     * @memberof InputTarget
     */
    customTargetType?: string;
    /**
     * 
     * @type {string}
     * @memberof InputTarget
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof InputTarget
     */
    targetType?: number;
    /**
     * 
     * @type {number}
     * @memberof InputTarget
     */
    zone: number;
}

/**
 * Check if a given object implements the InputTarget interface.
 */
export function instanceOfInputTarget(value: object): boolean {
    if (!('zone' in value)) return false;
    return true;
}

export function InputTargetFromJSON(json: any): InputTarget {
    return InputTargetFromJSONTyped(json, false);
}

export function InputTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputTarget {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'] == null ? undefined : json['active'],
        'coords': json['coords'] == null ? undefined : json['coords'],
        'customTargetType': json['custom_target_type'] == null ? undefined : json['custom_target_type'],
        'description': json['description'] == null ? undefined : json['description'],
        'targetType': json['target_type'] == null ? undefined : json['target_type'],
        'zone': json['zone'],
    };
}

export function InputTargetToJSON(value?: InputTarget | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'active': value['active'],
        'coords': value['coords'],
        'custom_target_type': value['customTargetType'],
        'description': value['description'],
        'target_type': value['targetType'],
        'zone': value['zone'],
    };
}

